import { useSelector } from 'react-redux';

import { useRouter } from 'next/router';

import { Route } from '@portal/common';
import { selectPermissions } from '@portal/store/src/user/selectors';

import SelfServiceHome from './home/self-service/index';

const Home = () => {
  const router = useRouter();
  const {
    shouldRedirectIndexPageToAccount,
    shouldUseExternalEntrypointOnIndexPage,
    shouldUseSelfServiceEntrypointOnIndexPage,
    shouldRedirectIndexEntryPointToHomePage,
    shouldRedirectIndexEntryPointToMciReports,
    shouldRedirectIndexEntryPointToBenchmarkReports,
  } = useSelector(selectPermissions);

  if (shouldRedirectIndexPageToAccount) {
    router.push('/accounts');

    return null;
  }

  if (shouldUseExternalEntrypointOnIndexPage) {
    if (shouldRedirectIndexEntryPointToHomePage) {
      router.push('/home');

      return null;
    }

    if (shouldRedirectIndexEntryPointToMciReports) {
      router.push(Route.MciReports);

      return null;
    }

    if (shouldRedirectIndexEntryPointToBenchmarkReports) {
      router.push('/benchmark-reports/funnel-summary');

      return null;
    }
  }

  if (shouldUseSelfServiceEntrypointOnIndexPage) {
    return <SelfServiceHome />;
  }

  return null;
};

export default Home;
